// ANA-R3-GEOM-03 — bridges the live OSD viewport projection from the Viewer
// (which owns OpenSeadragon privately) to the sibling `DrawOverlay`, which
// hosts the shared `PolygonEditor`. The Viewer publishes a `ViewerViewportApi`
// via `onViewportApiReady` whenever the view changes (pan / zoom / resize); the
// DrawOverlay reads it to build a `CoordinateTransform` whose `version` bumps on
// every change so the editor re-projects its vertices.
//
// Ephemeral UI state (Zustand) — never persisted; cleared on Viewer unmount.
import { create } from "zustand";
import type { ViewerViewportApi } from "@aeriosiq/ui";

interface ViewportApiState {
  api: ViewerViewportApi | null;
  setApi: (api: ViewerViewportApi | null) => void;
}

export const useViewportApiStore = create<ViewportApiState>((set) => ({
  api: null,
  setApi: (api) => {
    set({ api });
  },
}));
